import { useEffect, useRef, useState } from "react";

interface SSEEvent {
  type: string;
  data: Record<string, unknown>;
}

export function useSSE(url: string, enabled = true) {
  const [events, setEvents] = useState<SSEEvent[]>([]);
  const [connected, setConnected] = useState(false);
  const esRef = useRef<EventSource | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const es = new EventSource(url, { withCredentials: true });
    esRef.current = es;

    es.onopen = () => setConnected(true);
    es.onerror = () => setConnected(false);

    const handler = (e: MessageEvent) => {
      try {
        const data = JSON.parse(e.data);
        setEvents((prev) => [...prev.slice(-100), { type: e.type, data }]);
      } catch {
        /* ignore parse errors */
      }
    };

    // Listen for all custom event types
    for (const type of [
      "scraper:progress",
      "ingestion:progress",
      "ingestion:log",
      "ingestion:complete",
    ]) {
      es.addEventListener(type, handler);
    }

    return () => {
      es.close();
      esRef.current = null;
      setConnected(false);
    };
  }, [url, enabled]);

  return { events, connected };
}
